import { Col } from "antd";
import React from "react";
interface INewEntryFromRightColWrapperProps {
  children: React.ReactNode;
}
const RightCol: React.FC<INewEntryFromRightColWrapperProps> = ({
  children,
}) => {
  return (
    <Col xl={14} xxl={14} lg={14} md={24} sm={24} xs={24}>
      {children}
    </Col>
  );
};
export default RightCol;
